import { render } from "./MeiliLogsEdit.vue?vue&type=template&id=28e0dd5b"
import script from "./MeiliLogsEdit.vue?vue&type=script&lang=js"
export * from "./MeiliLogsEdit.vue?vue&type=script&lang=js"

import "./MeiliLogsEdit.vue?vue&type=style&index=0&id=28e0dd5b&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__